import { v4 as uuidv4 } from 'uuid'
const Images = [
    /*{
       category: "Instagram", 
       imgsrc: "./Images/",
       title: "Poster",
       id: uuidv4(),
       link: "", 
   },*/
    /*{
        brand_name: "", 
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Instagram", 
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Instagram", 
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Instagram", 
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Instagram", 
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Instagram",
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Instagram",
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Instagram",
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Instagram",
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Instagram",
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Instagram",
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "",
    },*/
    {
        category: "Instagram",
        imgsrc: "./Images/website_images/image_2.png",
        title: "Poster",
        id: uuidv4(),
        link: "https://www.instagram.com/p/CeBeb36BLV7/",
    },
    {
        category: "Instagram",
        imgsrc: "./Images/website_images/image_1.jpg",
        title: "Poster",
        id: uuidv4(),
        link: "https://www.instagram.com/nobel_roy_p",
    },
]
export default Images
